export const CREATE_GROUP = `
    mutation ($requestGroup:JSON,$photo:Upload){
        createGroup(requestGroup:$requestGroup,photo:$photo){
            message
            group {
                id
                name
                photo
            }
        }
    }
`;

export const UPDATE_GROUP = `
    mutation ($requestGroup:JSON,$photo:Upload){
        updateGroup(requestGroup:$requestGroup , photo:$photo){
            message
            group {
                id
                name
                photo
            }
        }
    }
`;